import { BaseMessageToSend, ContentMessageToSend, IMMessage, IMMessageType, MessageType } from './constant'

/**
 * 是否是多媒体消息
 * @param message
 * @returns
 */
export const isMultiMediaMessage = (message: ContentMessageToSend) => {
  return [MessageType.File, MessageType.Picture, MessageType.Video].includes(message.messageType)
}

/**
 * 待发送消息是否已就绪
 * @param message
 * @returns
 */
export const isMessagePrepared = (message: BaseMessageToSend) => {
  if ('messageType' in message) {
    const contentMessage = message as ContentMessageToSend
    return !isMultiMediaMessage(contentMessage) || !contentMessage.multimedia?.url?.startsWith('blob:')
  }
  return true
}

/**
 * 获取最后一条发送消息的格式化文本，用于展示在会话列表
 * @param message
 */
export const getLastMessageContent = (message: ContentMessageToSend | IMMessage) => {
  let lastContent = message.content || ''
  switch (message.messageType) {
    case MessageType.CardGoods:
    case MessageType.CardOrder:
      lastContent = '【Card】'
      break
    case MessageType.File:
      lastContent = '【File】'
      break
    case MessageType.Picture:
      lastContent = '【Picture】'
      break
    case MessageType.Video:
      lastContent = '【Video】'
      break
  }
  return lastContent
}

export function parseWsDataString(str: string) {
  const regex = /^(\d+):(\{[\s\S]*\})/
  const match = str.match(regex)
  if (match) {
    const code = Number(match[1]) // 匹配到的数字
    let jsonString = match[2]

    // 替换换行符
    jsonString = jsonString.replace(/[\n\t]/g, (char) => {
      return char === '\n' ? '\\n' : '\\t'
    })

    const data = JSON.parse(jsonString) // 冒号后面的内容

    return { code, data }
  } else {
    return null // 如果未匹配到任何内容，则返回 null
  }
}
